import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { wsFindBy } from 'services/WService';
import { Autocomplete } from '@material-ui/lab';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';

export default function ModalFile(props) {
  const File = props.model;
  const { id } = props;
  const [dataChanging, setDataChanging] = useState([]);
  const [activity, setActivitys] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listActivity() {
    let response = await wsFindBy('report/activity-report', { state: 'A' });
    if (response.success) setActivitys(response.data);
  }

  useEffect(() => {
    if (File.open) {
      listActivity();
    }
  }, [File.open]);

  useEffect(() => {
    if (activity.length > 0 && File.activity_report_id) {
      handleChange("activity_report_id", String(File.activity_report_id));
    }
  },[activity]);

  return (
    <Modal
      title="Nuevo Archivo de actividad"
      model={File}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="report/file-report"
      state
      dataForce={{
        activity_report_id: dataChanging.activity_report_id,
      }}
    >
      <Autocomplete
        disableClearable
        options={activity}
        getOptionLabel={(item) => `${item.description}`}
        renderInput={(params) => (
          <TextField {...params} label="Actividad" margin="normal" fullWidth required/>
        )}
        onChange={(e, item) => {
          handleChange('activity_report_id', item?.id);
        }}
        value={
          activity.find((act) => String(act.id) === String(dataChanging.activity_report_id)) ||
          null
        }
        style={{ flexGrow: 1, marginRight: '10px' }}
      />
      <FormControl fullWidth margin="normal" size="small">
        <InputLabel>Tipo</InputLabel>
        <Select
          required
          value={dataChanging.type ?? File.type ?? ''}
          onChange={(e) => handleChange('type', e.target.value)}
          inputProps={{ name: 'type' }}
        >
          <MenuItem value="xlsx">Imagen</MenuItem>
          <MenuItem value="arch">Archivo</MenuItem>
          <MenuItem value="rps">Reporte Supervisor</MenuItem>
        </Select>
      </FormControl>
      {(dataChanging.type ?? File.type) !== 'rps' ? (
        <>
          <TextField
            label="Ruta de archivo"
            type="text"
            name="file_route"
            margin="normal"
            fullWidth
            defaultValue={File.file_route || ''}
          />
          <TextField
            label="Nombre de archivo"
            type="text"
            name="file_name"
            margin="normal"
            fullWidth
            defaultValue={File.file_name || ''}
          />
        </>
      ) : undefined}
    </Modal>
  );
}
